import { extractNumbers } from '@/utils/extract-numbers';

/**
 * Valida telefone brasileiro (celular e fixo)
 * @param phone - Telefone a ser validado (pode conter parênteses, espaços e hífen)
 * @returns true se o telefone for válido, false caso contrário
 * @example
 * isValidPhone('(11) 99999-9999') // true (celular com DDD)
 * isValidPhone('11999999999') // true (celular sem formatação)
 * isValidPhone('(11) 3333-3333') // true (fixo com DDD)
 * isValidPhone('1133333333') // true (fixo sem formatação)
 * isValidPhone('999999999') // false (menos que 10 dígitos)
 * isValidPhone('119999999999') // false (mais que 11 dígitos)
 */
export const isValidPhone = (phone: string): boolean => {
  const cleanPhone = extractNumbers(phone);
  return cleanPhone.length >= 10 && cleanPhone.length <= 11;
};
